import moment from 'moment-timezone'

export default {
  methods: {
    formatAsDecimal: function(number, decimalPlaces = 2) {
      return parseFloat(number).toFixed(decimalPlaces)
    },
    formatAsPrice: function(number) {
      return '£' + this.formatAsDecimal(number)
    },
    formatAsPercent: function(number) {
      return parseFloat(Math.round(number * 100) / 100).toFixed(2) + '%'
    },
    formatAsSignedPercent: function(number) {
      let sign = ''
      if (number > 0) {
        sign = '+'
      } else if (number < 0) {
        sign = '-'
      }
      return sign + this.formatAsPercent(Math.abs(number))
    },
    formatAsUkDate: function(date) {
      return date ? moment(date).format('DD/MM/YYYY') : ''
    },
    formatAsUkDatetime: function(date) {
      if (!date) return ''

      // const zone = this.localTimeZoneAbbreviation()
      return moment(date)
        .tz('Europe/London')
        .format('DD/MM/YYYY HH:mm')
    },
    ukDateToIso: function(date) {
      return date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
    },
    ukDatetimeToIso: function(date) {
      return date
        ? moment(date, 'DD/MM/YYYY hh:mm').format('YYYY-MM-DD HH:mm:ss')
        : ''
    },
    isoDateToUk: function(date) {
      return date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    localTimeZone: function() {
      return moment.tz.guess()
    },
    localTimeZoneAbbreviation: function() {
      return moment.tz(this.localTimeZone()).zoneAbbr()
    },
    formatSecondsAsTime: function(seconds) {
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds - hours * 3600) / 60)
      const remainingSeconds = seconds - hours * 3600 - minutes * 60
      return [
        this.zeroPad(hours),
        this.zeroPad(minutes),
        this.zeroPad(remainingSeconds)
      ].join(':')
    },
    zeroPad: function(number, length) {
      let str = number.toString()
      while (str.length < (length || 2)) {
        str = '0' + str
      }
      return str
    },
    truncateString: function(str, length = 100, end = '...') {
      if (str.length > length) {
        return str.substring(0, length - end.length) + end
      } else {
        return str
      }
    },
    firstLineOrTruncateString: function(str, length = 100, end = '...') {
      if (str.indexOf('<br') === -1 || str.indexOf('<br') > length) {
        return this.truncateString(str, length, end)
      } else {
        return str.substring(0, str.indexOf('<br')) + end
      }
    },

    // Format dates to iso from data list
    datesToDb(data, datesProps) {
      for (const i in datesProps) {
        const prop = datesProps[i]
        if (data[prop] !== undefined && data[prop]) {
          data[prop] = moment(data[prop]).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      return data
    },
    // Leave only values with keys
    only(data, keys) {
      const ret = {}
      for (const i in keys) {
        if (_.has(data, keys[i])) {
          ret[keys[i]] = data[keys[i]]
        }
      }
      return ret
    },
    now() {
      return moment().format()
    },
    formatMetresToMiles: function(metres) {
      if (metres <= 1000) {
        return metres + 'm'
      } else {
        return Math.round(metres * 0.000621371192) + ' miles'
      }
    },
    formatDatetimeWithoutTimeZone: function(date) {
      if (!date) return ''

      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  }
}
